import React, {useCallback, useMemo, useState} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Components */
import HbLink from '../../../../../../components/Link/HbLink'

/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../../../../../modules/analytics/davinci/davinciConstants'
import {CATEGORY_SEARCH_KEYWORD_TITLE} from '../../../../../../modules/category/categoryConstants'

/* Styles */
import s from './search-keyword-row-list-view.scss'

const displayedItemLimitDesktop = 8
const displayedItemLimitMobile = 6
const maxItems = 20

const SearchKeywordRowListView = ({
  searchKeywordArray,
  className,
  title,
  pageTypeForDavinci,
  isMobile = false,
}) => {
  const [hideExtras, setHideExtras] = useState(true)
  const displayedItemLimit = isMobile ? displayedItemLimitMobile : displayedItemLimitDesktop

  const dataTestId = useMemo(() => title === CATEGORY_SEARCH_KEYWORD_TITLE.POPULAR_KEYWORDS
    ? 'popular-keyword-items'
    : title === CATEGORY_SEARCH_KEYWORD_TITLE.SUB_CATEGORIES
      ? 'sub-category-items'
      : null,
  [title]
  )

  const handleShowHideAll = useCallback(() => {
    setHideExtras((current) => !current)
  }, [])

  const handleLinkClick = ({keyword, url}) => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
      location: 'Popüler Aramalar',
      page_type: pageTypeForDavinci,
      page_value: window?.location?.pathname,
      placement: 'Popular Searches',
      text: keyword,
      url: url
    })
  }

  return (
    <div className={cx(s.root, className, {[s.mobile]: isMobile})}>
      <div className={s.container}>
        <h6 className={s.title}>{title}</h6>

        <ul className={s.list} data-test-id={dataTestId}>
          {
            searchKeywordArray?.slice(0, maxItems)?.map(({keyword, url}, index) => (
              <li
                className={cx(s.listItem, {
                  [s.listItemHidden]:
                  index > displayedItemLimit - 1 && hideExtras,
                })}
                key={
                  url
                }>
                <div
                  className={cx(s.searchKeywordRoot, className, {
                    [s.searchKeywordMobile]: isMobile,
                  })}>
                  <HbLink
                    onClick={() => handleLinkClick({keyword, url})}
                    className={s.link}
                    title={keyword}
                    to={url}>
                    <span className={s.text}>
                      {keyword}
                    </span>
                  </HbLink>
                </div>
              </li>
            ))
          }
          {
            searchKeywordArray?.length < displayedItemLimit || (
              <li className={cx(s.listItem)}>
                <button
                  onClick={handleShowHideAll}
                  className={s.showHideAllButton}>
                  <span>{hideExtras ? 'Tümünü Gör' : 'Kapat'}</span>
                  <i
                    className={cx(s.arrowIcon, {
                      [s.arrowIconUpsideDown]: !hideExtras,
                    })}/>
                </button>
              </li>
            )
          }
        </ul>
      </div>
    </div>
  )
}

SearchKeywordRowListView.propTypes = {
  className: PropTypes.string,
  searchKeywordArray: PropTypes.array,
  title: PropTypes.string,
}

export default SearchKeywordRowListView
